import { Auth, AuthResponse } from '@/api/auth';

export const mapAuthResponse = (data: AuthResponse): Auth => ({
  accessToken: data.access_token,
  expiresIn: data.expires_in,
  refreshToken: data.refresh_token,
});
